const groupedTableHeaders = [
  {
    text: "",
    name: "group",
    sortable: false,
    width: "130",
  },
  {
    text: "Тип упаковки",
    name: "type",
    type: "groupName",
    sortable: false,
    align: "left",
    width: "180",
  },
  {
    text: "Длина, м",
    name: "length",
    type: "defaultValue",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Ширина, м",
    name: "width",
    type: "defaultValue",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Высота, м",
    name: "height",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Количество",
    name: "quantity",
    type: "decimal",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Объем",
    name: "volume",
    type: "decimal",
    scale: 2,
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Поставки",
    name: "items",
    sortable: false,
    align: "left",
  },
];
const shippingsPackages = [
  {
    text: "Поставки",
    name: "group",
    sortable: false,
    align: "left",
  },
  {
    text: "Тип упаковки",
    name: "type",
    type: "groupName",
    sortable: false,
    align: "left",
    width: "180",
  },
  {
    text: "Длина, м",
    name: "length",
    type: "defaultValue",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Ширина, м",
    name: "width",
    type: "defaultValue",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Высота, м",
    name: "height",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Количество",
    name: "quantity",
    type: "decimal",
    sortable: false,
    align: "left",
    width: "100",
  },
  {
    text: "Объем",
    name: "volume",
    type: "decimal",
    scale: 2,
    sortable: false,
    align: "left",
    width: "100",
  },
];
export default {
  groupedTableHeaders,
  shippingsPackages,
};